/* engnosei v4.5 – κουτάκι ποσότητας (− ποσότητα +) στις κάρτες προϊόντων.
   Μετά την πρώτη προσθήκη στο καλάθι, το κουμπί «Προσθήκη στο καλάθι» της κάρτας γίνεται stepper.
   Στο 1 το «−» γίνεται κάδος (αφαίρεση). Στο 0 επιστρέφει το κουμπί.
   Συγχρονίζεται με τη μπάρα του καλαθιού (cart drawer) και με το /cart. */
(function () {
  if (window.__enQtyStepper) return;
  window.__enQtyStepper = true;

  var SEL = '.product-card-wrapper product-form';
  var DEBOUNCE = 350;
  var state = new Map();   // variantId -> { qty, key }
  var pending = new Map(); // variantId -> { want, timer, inflight, again }
  var lastCart = null;
  var loading = null;

  var SVG = function (d, w) {
    return '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="' + d +
      '" fill="none" stroke="currentColor" stroke-width="' + (w || 1.6) +
      '" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  };
  var ICON_MINUS = SVG('M3.5 8h9');
  var ICON_PLUS = SVG('M8 3.5v9M3.5 8h9');
  var ICON_TRASH = SVG('M2.8 4.5h10.4M6.4 4.5V3.3c0-.4.3-.8.8-.8h1.6c.5 0 .8.4.8.8v1.2M4.4 4.5l.6 8.2c0 .5.5.9 1 .9h4c.5 0 1-.4 1-.9l.6-8.2M6.8 7.2v3.9M9.2 7.2v3.9', 1.3);

  function cartUrl(path) {
    var r = window.routes || {};
    if (path === 'change') return (r.cart_change_url || '/cart/change') + '.js';
    return (r.cart_url || '/cart') + '.js';
  }

  function variantOf(form) {
    var input = form.querySelector('input[name="id"]');
    if (!input || input.disabled) return null;
    var v = parseInt(input.value, 10);
    return v > 0 ? v : null;
  }

  function titleOf(form) {
    var card = form.closest('.product-card-wrapper');
    var a = card && card.querySelector('.card__heading a');
    return a ? a.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function build(form) {
    if (form.dataset.enQty) return form.dataset.enQty !== 'skip';
    var vid = variantOf(form);
    if (!vid) { form.dataset.enQty = 'skip'; return false; }
    form.dataset.enQty = String(vid);

    var title = titleOf(form);
    var box = document.createElement('div');
    box.className = 'en-qty';
    box.hidden = true;
    box.setAttribute('role', 'group');
    box.setAttribute('aria-label', 'Ποσότητα στο καλάθι' + (title ? ': ' + title : ''));
    box.innerHTML =
      '<button type="button" class="en-qty__btn en-qty__minus" aria-label="Μείωση ποσότητας">' + ICON_MINUS + '</button>' +
      '<span class="en-qty__val" aria-live="polite" aria-atomic="true">' +
        '<span class="en-qty__n">1</span><span class="en-qty__lbl">στο καλάθι</span>' +
      '</span>' +
      '<button type="button" class="en-qty__btn en-qty__plus" aria-label="Αύξηση ποσότητας">' + ICON_PLUS + '</button>' +
      '<span class="en-qty__msg" role="status" hidden></span>';
    form.appendChild(box);

    box.querySelector('.en-qty__minus').addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation(); step(vid, -1);
    });
    box.querySelector('.en-qty__plus').addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation(); step(vid, 1);
    });
    return true;
  }

  function formsFor(vid) {
    return document.querySelectorAll(SEL + '[data-en-qty="' + vid + '"]');
  }

  function render(vid, qty) {
    formsFor(vid).forEach(function (form) {
      var box = form.querySelector('.en-qty');
      if (!box) return;
      var btn = form.querySelector('button[name="add"]');
      var wasShown = form.classList.contains('en-in-cart');

      if (qty > 0) {
        box.querySelector('.en-qty__n').textContent = qty;
        var minus = box.querySelector('.en-qty__minus');
        var mode = qty === 1 ? 'trash' : 'minus';
        if (minus.dataset.mode !== mode) {
          minus.innerHTML = mode === 'trash' ? ICON_TRASH : ICON_MINUS;
          minus.dataset.mode = mode;
          minus.setAttribute('aria-label', mode === 'trash' ? 'Αφαίρεση από το καλάθι' : 'Μείωση ποσότητας');
        }
        if (!wasShown && btn && btn.offsetHeight) box.style.height = btn.offsetHeight + 'px';
        box.hidden = false;
        form.classList.add('en-in-cart');
        if (!wasShown) {
          box.classList.remove('en-qty--pop');
          void box.offsetWidth;
          box.classList.add('en-qty--pop');
          if (btn && document.activeElement === btn) box.querySelector('.en-qty__plus').focus();
        }
      } else if (wasShown || !box.hidden) {
        var hadFocus = box.contains(document.activeElement);
        box.hidden = true;
        box.style.height = '';
        form.classList.remove('en-in-cart');
        if (hadFocus && btn) btn.focus();
      }
    });
  }

  function setBusy(vid, on) {
    formsFor(vid).forEach(function (form) {
      var box = form.querySelector('.en-qty');
      if (box) box.classList.toggle('en-qty--busy', on);
    });
  }

  function showMsg(vid, text) {
    formsFor(vid).forEach(function (form) {
      var msg = form.querySelector('.en-qty__msg');
      if (!msg) return;
      msg.textContent = text;
      msg.hidden = false;
      clearTimeout(msg._t);
      msg._t = setTimeout(function () { msg.hidden = true; }, 3500);
    });
  }

  function builtVariants() {
    var set = new Set();
    document.querySelectorAll(SEL + '[data-en-qty]').forEach(function (f) {
      var v = parseInt(f.dataset.enQty, 10);
      if (v > 0) set.add(v);
    });
    return set;
  }

  function applyCart(cart) {
    if (!cart || !cart.items) return;
    lastCart = cart;
    state.clear();
    cart.items.forEach(function (item) {
      var cur = state.get(item.variant_id);
      if (cur) cur.qty += item.quantity;
      else state.set(item.variant_id, { qty: item.quantity, key: item.key });
    });
    builtVariants().forEach(function (vid) {
      var p = pending.get(vid);
      var line = state.get(vid);
      render(vid, p ? p.want : (line ? line.qty : 0));
    });
  }

  function refresh() {
    if (loading) return loading;
    loading = fetch(cartUrl('cart'), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(applyCart)
      .catch(function () {})
      .then(function () { loading = null; });
    return loading;
  }

  function renderDrawer(cart) {
    var drawer = document.querySelector('cart-drawer');
    var sections = cart.sections || {};
    if (drawer && typeof drawer.renderContents === 'function' && sections['cart-drawer']) {
      drawer.renderContents(cart);
    } else if (sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      var html = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (bubble && html) bubble.innerHTML = html.innerHTML;
    }
    if (drawer) drawer.classList.toggle('is-empty', cart.item_count === 0);
    if (document.getElementById('main-cart-items') && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'en-qty', cartData: cart });
    }
  }

  function step(vid, delta) {
    var line = state.get(vid);
    var p = pending.get(vid);
    if (!p) {
      p = { want: line ? line.qty : 0, timer: null, inflight: false, again: false };
      pending.set(vid, p);
    }
    p.want = Math.max(0, p.want + delta);
    render(vid, p.want);
    clearTimeout(p.timer);
    p.timer = setTimeout(function () { flush(vid); }, DEBOUNCE);
  }

  function flush(vid) {
    var p = pending.get(vid);
    if (!p) return;
    p.timer = null;
    if (p.inflight) { p.again = true; return; }

    var line = state.get(vid);
    if (!line) { pending.delete(vid); refresh(); return; }
    if (line.qty === p.want) { pending.delete(vid); render(vid, line.qty); return; }

    p.inflight = true;
    setBusy(vid, true);
    fetch(cartUrl('change'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: line.key,
        quantity: p.want,
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        p.inflight = false;
        var data = res.data || {};
        if (!res.ok || data.status) {
          pending.delete(vid);
          showMsg(vid, data.description || data.message || 'Δεν ήταν δυνατή η αλλαγή της ποσότητας.');
          return refresh();
        }
        var again = p.again;
        p.again = false;
        if (!again && p.timer === null) pending.delete(vid);
        applyCart(data);
        renderDrawer(data);
        if (again) flush(vid);
      })
      .catch(function () {
        p.inflight = false;
        pending.delete(vid);
        showMsg(vid, 'Δεν ήταν δυνατή η αλλαγή της ποσότητας.');
        refresh();
      })
      .then(function () { setBusy(vid, false); });
  }

  function scan() {
    var added = false;
    document.querySelectorAll(SEL + ':not([data-en-qty])').forEach(function (f) {
      if (build(f)) added = true;
    });
    if (!added) return;
    if (lastCart) applyCart(lastCart);
    else refresh();
  }

  function init() {
    scan();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === 'en-qty') return;
        refresh();
      });
    }
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(scan, 150);
    }).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
